export enum CustomRoutes {
  DISPENSER_AGREEMENT_DETAILS = 'dispenserAgreementDetails',
  CREATE_DISPENSER_AGREEMENT = 'createDispenserAgreement',
  DISPENSER_AGREEMENT_HISTORY = 'dispenserAgreements',
  CREATE_CREDIT_CLAIM_ORDER = 'createCreditClaimOrder',
  CREATE_CREDIT_CLAIM = 'createCreditClaim',
  CREATE_REBATE_CLAIM = 'createRebateClaim',
  ORDER_HISTORY = 'orders',
  ORDER_DETAIL = 'order',
  CART = 'cart',
  CHECKOUT = 'checkout',
  SAVED_CARTS = 'savedCarts',
  IMPORT_SAVED_CART = 'importCSVSavedCartPage',
  PRICE_SUPPORT_AGREEMENT_HISTORY = 'priceSupportAgreements',
  PRICE_SUPPORT_AGREEMENT_DETAILS = 'priceSupportAgreementDetails',
  DISPENSER_AGREEMENT_SHIPMENT_HISTORY = 'dispenserAgreementShipmentHistory',
  DISPENSER_AGREEMENT_SHIPMENT_DETAILS = 'dispenserAgreementShipmentDetails',
  DISPENSER_AGREEMENT_PLACE_ORDER = 'dispenserAgreementPlaceOrder',
  REBATE_CLAIM_DETAILS = 'rebateClaim',
  REBATE_CLAIMS = 'rebateClaims',
  NEW_DISPENSER_CREDIT_REQUEST = 'newDispenserCreditRequest',
  CREDIT_CLAIMS = 'creditClaims',
  CREDIT_CLAIM_DETAILS = 'creditClaim',
  ORDER_CONFIRMATION = 'order-confirmation',
  ACCOUNT_SUMMARY = 'accountSummary',
  SHIPMENT_CREDIT_CLAIM = 'shipmentCreditClaim',
  SHIPMENT_CREDIT_CLAIM_HISTORY = 'shipmentCreditClaimHistory',
  SHIPMENT_CREDIT_CLAIM_DETAIL = 'shipmentCreditClaimDetail',
  UPDATE_DISPENSER_AGREEMENT = 'updateDispenserAgreement',
  CANCEL_DISPENSER_AGREEMENT = 'cancelDispenserAgreement'
}
